import ReactDOM from 'react-dom';
import { BrowserRouter  } from 'react-router-dom';
import App from 'src/App';
import { SidebarProvider } from 'src/contexts/SidebarContext';

// @ts-ignore
// @ts-ignore
ReactDOM.render(
    <SidebarProvider>
      <BrowserRouter children={(<App/>)} />

    </SidebarProvider>,
  document.getElementById('root')
);
